import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './PaymentResultPage.module.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useSystemLogin } from '../contexts/SystemLoginContext';

const PaymentSuccessPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const systemLogin = useSystemLogin();
  
  const params = new URLSearchParams(location.search);
  const orderId = params.get('orderId');

  const handleBack = () => {
    navigate('/recharge');
  };

  const handleViewHistory = () => {
    navigate('/recharge-history');
  };

  if (!systemLogin.isLoggedIn) {
    return (
      <div className={styles.container}>
        <Header />
        <div className={styles.content}>
          <div className={styles.loginPrompt}>
            <h2>请先登录</h2>
            <p>登录后即可查看支付结果</p>
            <button onClick={() => navigate('/login')} className={styles.loginButton}>
              前往登录
            </button>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <header className={styles.header}>
          <button onClick={handleBack} className={styles.backButton}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" className={styles.backIcon}>
              <path d="M19 12H5M12 19l-7-7 7-7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            返回
          </button>
          <h1 className={styles.title}>支付结果</h1>
        </header>

        <main className={styles.main}>
          <div className={styles.resultCard}>
            <div className={styles.successIcon}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M9 12l2 2 4-4" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="12" cy="12" r="9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            
            <div className={styles.resultMessage}>
              <h2>支付成功</h2>
              <p>您的充值已完成，余额将立即到账</p>
            </div>
            
            {orderId && (
              <div className={styles.orderInfo}>
                <span className={styles.orderLabel}>订单号：</span>
                <span className={styles.orderValue}>{orderId}</span>
              </div>
            )}
            
            <div className={styles.buttonGroup}>
              <button className={styles.primaryButton} onClick={handleBack}>
                返回充值
              </button>
              <button className={styles.secondaryButton} onClick={handleViewHistory}>
                查看记录
              </button>
            </div>
          </div>
        </main>
      </div>
      
      <Footer />
    </div>
  );
};

export default PaymentSuccessPage;